<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        06.17
        <br />2016
      </span>
      <span class="tiel">美菜网刘传军变身“超级采购员”，确保“新鲜低价”</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/a478a1f071f532e9990503cfa127e2d4.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        至今年6月，美菜已创立了两年。两周年之际，创始人刘传军亲自率美菜员工二十余人，亲访山东济南、淄博、寿光等农产品基地进行考察。
        <br />
        <br />在过去五年的时间里，刘传军每年都会不定期的走访全国各地的农产品基地，一是为了考察农产品的质量是否安全合格，保障舌尖上的安全；二是为了把控农产品价格走势，始终走在市场变化的前端；第三更是希望大家都能够吃上新鲜低价的蔬菜。于是，刘传军“超级采购员”的别名由此而来。
        <br />
        <br />为什么叫“超级采购员”呢？是因为刘传军对果蔬的挑选到了严苛的地步。在基地负责人的陪同下，刘传军带领团队走访基地一线的种植区、设备区、分拣区… …实地考察土壤、温差、施肥、收割期、交通运输、种植技术、管理模式等情况。刘传军表示，“我们挑选合作基地必须严格，只有这样才能保证蔬菜的品质与价格，才能保证各种优质蔬菜的供给。”为了深化采购标准，他主张从选种、施肥，到种植技术的指导，再到抽检等系列环节去加以监控，从源头确保蔬菜的品质。他说只选择最优质的蔬菜，不能拿些差的、坏的、烂的蔬菜来凑数。这个时候你就会发现，他特别严谨，一就是一，二就是二，绝不容忍凑合的做法。
        <br />
        <br />在考察淄博基地过程中，刘传军总是不厌其烦地询问有关蔬菜种植的各种问题，小到施肥频次、采摘时间，大到种植技术、运输管理，只要是对蔬菜有影响的问题，他都要刨根问底、弄个明白。“从没见过这样的采购人，已经严谨到苛刻的地步了，好像非得深究到蔬菜基因上才肯罢休。”基地负责人笑道，“就连和菜农一块吃饭这个时间点，都不会放过任何提问的机会。”
        <br />
        <br />刘传军为什么会如此重视采购基地的考察，甚至亲力亲为地紧抓这块工作呢？他认为，源头直采可以保证菜品“新鲜、低价”。我们不妨将源头直采看成是田间到餐厅的直通车，因为取消了中间环节，从而大大缩短了生鲜食材采摘后送到餐厅的时间。这不仅最大程度的保留了菜品的新鲜度，还避免了多梯次批发层层加价的情况出现。自然而然，源头直采的收购价格比传统采购要便宜许多。
        <br />
        <br />美菜与各大种植基地建立合作关系的初衷，就是实现生鲜平台与采购源头的直接对接，使得能够对农产品源头进行严格把关，优化流通环节，直供餐厅，让各大小餐厅采购到新鲜又便宜的食材。美菜配送负责人表示，因为在各地建立了合作基地，配送中优选就近原则，很多时候，前一天采摘的蔬菜，第二天早上10点前就能送达餐厅。
        <br />
        <br />刘传军作为美菜的超级采购员，严格把控着农产品的品质问题。以身作则，为公司的每一个成员树立榜样，带动他们做好采购工作，帮助全国千万家餐厅采购到“新鲜、低价”的生鲜食材。在美菜，“超级采购员”不仅仅是刘传军的专属外号，也是美菜每一个小伙伴的奋斗目标。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
